export const Pairs = [
  {
   title: "FTT",
   submenu: [
     {
       title: "Futures",
       subtext: [
        {title: 'FTT/PERP'}
       ]
     },
     {
       title: "Spot",
       subtext: [
        {title: [
          'FTT/BTC',
          'FTT/JPY',
          'FTT/USD',
          'FTT/USDT'
        ]}
       ]
     }
   ]
  },
  {
   title: "BTC",
   submenu: [
    {
      title: "Futures",
      subtext: [
       {title: [
        'BTC-PERP',
        'BTC-0624',
        'BTC-0930',
        'BTC-1230'
       ]}
      ]
    },
    {
      title: "Spot",
      subtext: [
       {title: [
         'BTC/EUR',
         'BTC/JPY',
         'BTC/USD',
         'BTC/USDT'
       ]}
      ]
    }
   ]
  },
  {
    title: "ETH",
    submenu: [
     {
       title: "Futures",
       subtext: [
        {title: [
         'ETH-PERP',
         'ETH-0624',
         'ETH-0930',
         'ETH-1230'
        ]}
       ]
     },
     {
       title: "Spot",
       subtext: [
        {title: [
          'ETH/BTC',
          'ETH/EUR',
          'ETH/JPY',
          'ETH/USD',
          'ETH/USDT'
        ]}
       ]
     }
    ]
  },
  {
    title: "Futures"
  },
  {
    title: "Spot"
  },
  {
    title: "Leveraged Tokens"
  },
  {
    title: "Volatility"
  },
  {
    title: "Prediction"
  },
  {
    title: "Fiat"
  },
  {
    title: "Recent"
  }
 ];
